<template>
  <div :class="$style.container">
    <Title :title-params="item.title" :class="$style.title" />
    <RichText
      v-if="item.description"
      :text-params="item.description"
      :class="$style.description"
    />
    <template v-if="item.solution_title && item.solution_title.length">
      <Title
        :title-params="item.solution_title"
        :class="$style.solution_title"
      />
      <RichText
        :text-params="item.solution_description"
        :class="$style.solution_description"
      />
    </template>
  </div>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'

export default {
  name: 'LukonTerminationBoxStep',
  components: {
    Title,
    RichText,
  },

  props: {
    item: {
      type: Object,
      default: {},
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 15px;
  padding: 25px 20px;
  border: 2px solid #eae9e3;
  border-radius: 8px;
}
.title {
  font-size: 20px;
  line-height: 32px;
}
.description {
  color: $gray-700;
  font-size: 16px;
}

.solution_title {
  margin: 20px 0;

  color: $gray-600;
}
.solution_description {
  margin-top: 20px 0;
}
</style>
